function addCandidate(candidates, value) {
  if (typeof value !== 'string') return
  if (!value || candidates.includes(value)) return
  candidates.push(value)
}

function isBase64Like(value) {
  return value.length % 4 === 0 && /^[A-Za-z0-9+/=]+$/.test(value)
}

export function parseStoredJson(value) {
  const candidates = []
  addCandidate(candidates, value)

  for (let i = 0; i < candidates.length && i < 30; i++) {
    const candidate = candidates[i]

    try {
      addCandidate(candidates, decodeURIComponent(candidate))
    } catch {}

    if (typeof atob === 'function' && isBase64Like(candidate)) {
      try {
        const decoded = atob(candidate)
        addCandidate(candidates, decoded)
        addCandidate(candidates, decodeURIComponent(decoded))
      } catch {}
    }

    try {
      const parsed = JSON.parse(candidate)
      if (parsed && typeof parsed === 'object') return parsed
      addCandidate(candidates, parsed)
    } catch {}
  }

  return null
}

export function getStoredUserData() {
  const raw = localStorage.getItem('userData')
  const user = parseStoredJson(raw)

  if (raw && user) {
    localStorage.setItem('userData', JSON.stringify(user))
  } else if (raw && !user) {
    localStorage.removeItem('userData')
  }

  return user
}
